/**
 * Alte Links des Preisautomatik-Kalenders (`/dynamic-pricing/calendar?start&days&apartments&selected`)
 * landen in Verfügbarkeit & Vertrieb: mit gewähltem Tag oder genau einem Apartment im Monat dieses
 * Apartments, sonst im Grundkalender ab demselben Tag und mit derselben Länge.
 */
import { AVAILABILITY_ZOOMS, type AvailabilitySearch } from './availabilitySearch';
import { isIsoDate } from './calendar/calendarDates';

export interface LegacyCalendarSearch {
  start?: string;
  days?: number;
  apartments?: string;
  selected?: string;
}

export function validateLegacyCalendarSearch(
  search: Record<string, unknown>,
): LegacyCalendarSearch {
  return {
    start: isIsoDate(search.start) ? search.start : undefined,
    days: Number.isFinite(Number(search.days)) ? Number(search.days) : undefined,
    apartments: typeof search.apartments === 'string' ? search.apartments : undefined,
    selected: typeof search.selected === 'string' ? search.selected : undefined,
  };
}

export function legacyCalendarTarget(search: LegacyCalendarSearch): AvailabilitySearch {
  const [selectedId, selectedDate] = search.selected?.split(':') ?? [];
  const day = selectedId && isIsoDate(selectedDate) ? selectedDate : undefined;
  const ids = search.apartments?.split(',').filter(Boolean) ?? [];
  const apartment = day ? selectedId : ids.length === 1 ? ids[0] : undefined;
  if (apartment) {
    return { apartment, day, month: (day ?? search.start)?.slice(0, 7) };
  }
  return {
    from: search.start,
    days: AVAILABILITY_ZOOMS.find((zoom) => zoom === search.days),
  };
}
